'use strict';
 /**
 * @author Maxim Seredkin
 */
ProjectModalCreateController.$inject = ['$scope', '$routeParams', '$window', '$uibModalInstance', '$uibModal', 'project'];

export default function ProjectModalCreateController($scope, $routeParams, $window, $modalInstance, $modal, project) {

    defaut();

    function defaut() {
        $scope.project = {};
        angular.copy(project, $scope.project);
        if (!$scope.project.projectOkveds)
            $scope.project.projectOkveds = [];
    }

    $scope.ok = function () {
        $modalInstance.close($scope.project);
    };

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

}